import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { getSequnceSort, textTrim } from "../../utils/helper";
import ReactTooltip from "react-tooltip";
const Header = ({ activityData, currentSceneObj, handleMove, loginType, getTab, }) => {
    // console.log("activityData : ", activityData);
    const isMoveToLesson = (lesson, sceneIndex)=>{
        let isNext = false;
        if(true){
            if(!lesson?.isCompleted){
                isNext = true;
            }
            if (lesson?.kc?.length > 0 && lesson?.kc?.some((item)=> !item?.attempted )){
                    isNext = true;
            }
            if(activityData?.series?.scenes?.length > 0){
              let prevSceenObj = getSequnceSort(activityData?.series?.scenes)[sceneIndex-1];
              if(prevSceenObj?.isCompleted && prevSceenObj?.kc?.length === 0){
                isNext = false

              }else if(prevSceenObj?.isCompleted && prevSceenObj?.kc?.every((item)=> item?.attempted )){
                isNext = false;
              }
            }
            

        }
        return isNext;
    }
    return (
        <div className="panneltitles ">
            <div className="contenttitle flexone">
                {(getTab === "Lessons" || getTab === "Reflection") ? (
                    <h2 className="flextwo "><span>Module {activityData?.activitySequence} <i class="fa-sharp fa-regular fa-angle-right ml-3 mr-3"></i> </span>
                        Lesson {currentSceneObj?.sequence}: {" "}
                        <React.Fragment>
                            {currentSceneObj?.name?.length > 39 ? (
                                <ReactTooltip id={currentSceneObj?.name} className={"tooltip"}>
                                    <p data-id={`${currentSceneObj?.name} _Course_activity_name`} >
                                        {currentSceneObj?.name}
                                    </p>
                                </ReactTooltip>
                            ) : (
                                ""
                            )}

                            <div data-for={currentSceneObj?.name} data-event-off='' data-tip className="ml-1">
                                {textTrim(currentSceneObj?.name, 39)}
                            </div>
                        </React.Fragment>
                    </h2>
                ) : (
                    <h2 className="flextwo ">
                        <span>Module {activityData?.activitySequence} <i class="fa-sharp fa-regular fa-angle-right ml-3 mr-3"></i>
                        </span>
                        {getTab === "Characters" ? "Characters" : "Challenge"}
                    </h2>
                )}
                {/* <span className="mybaricons"><i class="fa-regular fa-bars"></i></span> */}

                {
                    // getTab === "Lessons" && 
                    (
                    <div className="jumptopagescene dropdownlistmodl">
                    <span className="mybaricons  pointer"
                        aria-haspopup="true"
                        aria-expanded="false"
                        id={`barlistsubdropdown`}
                        data-toggle="dropdown"><i class="fa-regular fa-bars"></i></span>
                    <ul className="dropdown-menu dropdown-menu-end lession_list" aria-labelledby={`barlistsubdropdown`}>
                        {getSequnceSort(activityData?.series?.scenes)?.map((data, index) => (
                            <li className={`pointer d-flex align-items-center ${currentSceneObj?.id === data?.id && "Active_lession"}`} key={index}>
                                <p className="text-left d-flex align-items-center" onClick={() => { (!loginType || !isMoveToLesson(data, index)) && handleMove(index) }}>
                                    <span class="mr-1 jumponscene">{index + 1}</span>
                                    <div className="text-left ml-3">
                                        <span class="juweeknametext">
                                        {data?.name}
                                        </span>
                                        <span class="juweeknametextSubTitle text-left">
                                             {activityData?.secScCount === index+1 ? "Exercise" : data?.kc?.length > 0 ? "Knowledge Check" : "Real World application"}
                                        </span>
                                    </div>
                                </p>
                                {loginType && (
                                    data?.isCompleted ? (
                                        <span class="circleone"><i class="fa-solid fa-check"></i></span>
                                    ) : (currentSceneObj?.id !== data?.id && isMoveToLesson(data, index))  && (
                                        <span><i class="fa-solid fa-lock-keyhole mr-2"></i></span>
                                    )
                                )}
                            </li>
                        ))}
                        {/* <li className="pointer d-flex align-items-center  ">
                                <p className="text-left d-flex align-items-center">
                                    <span class="mr-1 jumponscene">1</span>
                                    <div><span class="juweeknametext">What is Self-Confidence?</span><span class="juweeknametextSubTitle">Real World application </span></div>
                                </p>
                                
                            </li>
                              <li className="pointer d-flex align-items-center  ">
                                <p className="text-left d-flex align-items-center">
                                    <span class="mr-1 jumponscene">2</span>
                                    <div><span class="juweeknametext">What is Self-Confidence?</span><span class="juweeknametextSubTitle">Real World application </span></div>
                                </p>
                                
                            </li>
                              <li className="pointer d-flex align-items-center  ">
                                <p className="text-left d-flex align-items-center">
                                    <span class="mr-1 jumponscene">3</span>
                                    <div><span class="juweeknametext">What is Self-Confidence?</span><span class="juweeknametextSubTitle">Real World application </span></div>
                                </p>
                                
                            </li> */}
                    </ul>
                </div>
                )}

            </div>
        </div >

    )
}
export default Header;